import { getCounter } from '../lib/api.js';

export function mountCounter(el) {
  el.setAttribute('data-test', 'counter');
  el.textContent = '🌈 — cases processed';
  getCounter().then((total) => {
    if (total == null) {
      el.style.display = 'none';
      return;
    }
    el.textContent = `🌈 ${total.toLocaleString('en-US')} cases processed`;
  });
}
